module.exports = "/assets/data/96dea344e95ba2c03a959e1229d11237-KA6.data.json";